import { DatePipe } from "@angular/common";
import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  OnChanges,
  Output,
  Renderer2,
  SimpleChanges,
  ViewChild,
  ViewEncapsulation,
} from "@angular/core";

import { CalendarDirective, CalendarType } from "../calendar.directive";

@Component({
  selector: "ui-quick-navigation",
  templateUrl: "./quick-navigation.component.html",
  styleUrls: ["./quick-navigation.component.scss"],
  encapsulation: ViewEncapsulation.Emulated,
})
export class QuickNavigationComponent extends CalendarDirective implements OnChanges {
  constructor(public changeDetectorRef: ChangeDetectorRef, private datePipe: DatePipe, private renderer: Renderer2) {
    super(changeDetectorRef);
  }

  @Output()
  readonly resolutionChange: EventEmitter<CalendarType> = new EventEmitter<CalendarType>();

  @ViewChild("displayMonth")
  public displayMonth!: ElementRef<HTMLElement>;
  @ViewChild("displayYear")
  public displayYear!: ElementRef<HTMLElement>;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.active.currentValue) {
      if (this.displayMonth) {
        const month = this.datePipe.transform(changes.active.currentValue.start, "LLLL");
        if (month) this.renderer.setProperty(this.displayMonth.nativeElement, "innerText", month);
      }
      if (this.displayYear) {
        const year = this.datePipe.transform(changes.active.currentValue.start, "yyyy");
        if (year) this.renderer.setProperty(this.displayYear.nativeElement, "innerText", year);
      }
    }
  }

  zoomIn(resolution: CalendarType) {
    // Then zoom into the resoution.
    this.resolutionChange.emit(resolution);
  }
  zoomOut(): void {
    // Reset resolution to its default one.
    this.resolutionChange.emit(this.type);
  }
}
